var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regulations"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"page-name"},[_vm._v(_vm._s(_vm.$t("amlkyc.title")))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }